// The Haney layer is painted when the sidebar asks for it. The server runs the
// same local-neighborhood ordinary kriging, so the colours are that surface.
import { postJson } from "../api/httpGateway";

export interface HaneyKrigePoint {
  lng: number;
  lat: number;
  value: number;
}

interface HaneyKrigeOut {
  values: (number | null)[];
}

export async function krigeHaney(
  points: HaneyKrigePoint[],
  centroids: { lng: number; lat: number }[],
): Promise<(number | null)[]> {
  const data = await postJson<HaneyKrigeOut>("/haney/krige", {
    points,
    centroids,
  });
  return data.values;
}
